var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-banner", class: _vm.classObject },
    [
      _vm.backLink && !_vm.withSearchField
        ? _c("ob1-liens", {
            attrs: {
              text: _vm.backLink,
              "with-arrow": "",
              "is-back": "",
              href: "#",
            },
            on: { "ob1-liens-click": _vm.backHandler },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.withSearchField
        ? _c("equipment-search-field", {
            staticClass: "me-2 w-100",
            attrs: {
              "place-holder": _vm.searchFieldPlaceHolder,
              "search-results-url": _vm.searchResultsUrl,
              "search-results-query-additional-params":
                _vm.searchResultsQueryAdditionalParams,
              "algolia-api-key": _vm.algoliaApiKey,
              "algolia-app-id": _vm.algoliaAppId,
              "algolia-index-name": _vm.algoliaIndexName,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCart
        ? _c("span", { staticClass: "visually-hidden" }, [
            _vm._v(
              "Lien vers le panier qui contient " +
                _vm._s(_vm.numberOfItems) +
                " articles"
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCart
        ? _c(
            "a",
            {
              staticClass: "cart-icon no-decoration",
              class: _vm.aClass,
              attrs: { href: _vm.href, "aria-disabled": !_vm.cartEnabled },
              on: { click: _vm.cartClickHandler },
            },
            [
              _c("span", {
                staticClass: "icon",
                class: _vm.classObjectIcon,
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.numberOfItems !== 0,
                    expression: "numberOfItems !== 0",
                  },
                ],
                class: _vm.numberCssClasses,
                domProps: { innerHTML: _vm._s(_vm.numberOfItems) },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }